import React from 'react'
import Icon from '../../Icon'
import { useTranslation } from 'react-i18next'
import { IProps, LinkCategory } from '../types'
import { iconForLinkType } from '../utils'
import Link from '../Link'
import LoadingIndicator from '../../LoadingIndicator'
import { Sizes, IndicatorTheme } from '../../LoadingIndicator/types'

const formatDate = (date: string | undefined, t: Function) => {
    if (date) {
        const dateobj = new Date(date)
        if (!dateobj) return {}
        const shortMonthString = t(`date.months.${dateobj.getMonth()}`).substr(
            0,
            3
        )
        return {
            month: shortMonthString,
            day: dateobj.getDate(),
            year: dateobj.getFullYear(),
        }
    }
    return {}
}

const LinkBadge = (props: IProps) => {
    const { t } = useTranslation()
    const classes = `${props.size} ${props.disabled ? '--disabled' : ''}`
    
    const formattedDate = formatDate(props.date, t)

    const colorTheme = props.colorTheme ? `--${props.colorTheme}` : ''

    const onBadgeClick = (e: any) => {
        if (props.onClick && !props.disabled) {
            props.onClick(e)
        } else {
            return
        }
    }

    const renderWrapper = (children: React.ReactNode) => {
        if (props.onClick) {
            return (
                <button className={`link-badge__container ${classes} link-badge__container${colorTheme}`} onClick={onBadgeClick}>
                    {children}
                </button>
            )
        }
        return <div className={`link-badge__container ${classes} link-badge__container${colorTheme}`}>{children}</div>
    }

    const content = (
        <div className={`link-badge linkbadge-root ${classes} link-badge${colorTheme}`}>
            {renderWrapper(
                <>
                <div className='link-badge__top-container'>
                    {!props.hideIcon && (
                        <div className={`link-badge__description-icon ${classes} desc-icon link-badge__description-icon${colorTheme}`}>
                            {props.category !== LinkCategory.News &&
                                props.badgeIcon && (
                                    <Icon
                                        iconName={props.badgeIcon}
                                    />
                                )}
                            {props.category === LinkCategory.News &&
                                formattedDate && (
                                    <div className={`link-badge__news-date ${classes} link-badge__news-date${colorTheme}`}>
                                        <span>{formattedDate.day}</span>
                                        <span>{formattedDate.month}</span>
                                        <span>{formattedDate.year}</span>
                                    </div>
                                )}
                        </div>
                    )}
                    {props.loading ? (
                        <LoadingIndicator
                            size={Sizes.Medium}
                            hideText={true}
                            theme={IndicatorTheme.Inverted}
                        />
                    ) : (
                        <>
                            <div className={`link-badge__link-text-wrapper ${classes} link-badge__link-text-wrapper${colorTheme}`}>
                                <span className={`link-badge__link-text ${classes} link-badge__link-text${colorTheme}`}>
                                    {props.title}
                                </span>
                            </div>
                            <div className={`link-badge__link-icon ${classes} link-badge__link-icon${colorTheme}`}>
                                <Icon
                                    iconName={iconForLinkType(props.linkType)}
                                ></Icon>
                            </div>
                        </>
                    )}
                </div>
                <div className={`link-badge__content-container ${classes} link-badge__content-container${colorTheme}`}>
                    <span className='link-badge__content-text'>{props.teaser}</span>
                </div>
                </>
            )}
        </div>
    )

    if (!props.onClick) {
        return (
            <div className={`link-badge__link-wrap ${props.size || 'md'}`}>
                <Link
                    type={props.linkType}
                    url={props.link || ''}
                    title={props.title}
                >
                    {content}
                </Link>
            </div>
        )
    }
    return <div className={`link-badge__link-wrap ${props.size || 'md'}`}>{content}</div>
}

export default LinkBadge